// extracted by mini-css-extract-plugin
export default {"content":"admin_content__p+jPF","head":"admin_head__Jkvtw"};